import * as Yup from 'yup';

export const validationSchema = (state, formValues) => {
    const isBoolCustomer = formValues?.valueType?.value === 'bool' && formValues?.type?.value === 'customer';
    const isIntCustomer = formValues?.valueType?.value === 'integer' && formValues?.type?.value === 'customer';
    let schema = {
        name: Yup.string().required('Enter Attribute Name'),
        type: Yup.mixed().required('Select Type'),
        valueType: Yup.mixed().required('Enter Value Type'),
    };

    if (isBoolCustomer) {
        schema.SelfcareAttribute = Yup.array()
            .of(Yup.mixed())
            .min(2, 'You must select at least 2 values for Selfcare Attribute')
            .required('Kindly Enter the attribute value');
    }
    if (!isBoolCustomer && (isIntCustomer && formValues?.valueFormat?.value !== "sequence")) {
        schema.minimumValue = state ? Yup.number().required('Enter Minimum Value') : Yup.number();
        schema.maximumValue = state ? Yup.number().required('Enter Maximum Value') : Yup.number();
    }
    return Yup.object().shape(schema);
}
